import { render } from "./UiRadio.vue?vue&type=template&id=5b05dcba&scoped=true"
import script from "./UiRadio.vue?vue&type=script&lang=js"
export * from "./UiRadio.vue?vue&type=script&lang=js"

import "./UiRadio.vue?vue&type=style&index=0&id=5b05dcba&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b05dcba"]])

export default __exports__